import { PureComponent, ReactNode } from 'react';
import { BedFilledIcon, backArrowIcon, closeIcon, preferencesIcon } from '../common/Icons';
import { getIpdConfig } from '../../store/localstorage';
import { BedsEntity } from '../../api/getIpdConfigData';
import getIpdBedAvailibility from '../../api/getIpdBedAvailibility';
import { Modal } from 'antd';

type State = {
    selectedBed?: string;
    selectedCats: Set<string>;
    avaialbleBeds?: Set<string>;
};

type Props = {
    isVisible: boolean;
    closeMe: (bed?: BedsEntity, catId?: string) => void;
};

class IpdBedSelect extends PureComponent<Props, State> {
    cats = getIpdConfig()?.categories || [];
    rooms = getIpdConfig()?.rooms || [];
    beds = getIpdConfig()?.beds || [];

    state: State = {
        selectedBed: undefined,
        selectedCats: new Set(this.cats.map((t) => t.id)),
    };

    async componentDidMount(): Promise<void> {
        const response = await getIpdBedAvailibility();
        if (response.success) {
            this.setState({ avaialbleBeds: new Set(response.data?.map((t) => t.id)) });
        }
    }

    onCatToggle = (id: string): void => {
        const { selectedCats } = this.state;
        if (selectedCats.has(id)) {
            selectedCats.delete(id);
        } else {
            selectedCats.add(id);
        }
        this.setState({ selectedCats: new Set(selectedCats) });
    };

    onBedSelect = (id: string): void => {
        this.setState({ selectedBed: this.state.selectedBed === id ? undefined : id });
    };

    render(): ReactNode {
        const { selectedBed, selectedCats, avaialbleBeds } = this.state;
        const { closeMe, isVisible } = this.props;

        return (
            <Modal
                onCancel={(e) => {
                    e.stopPropagation();
                    closeMe();
                }}
                width={720}
                closable={false}
                visible={isVisible}
                destroyOnClose
                footer={null}
                bodyStyle={{
                    padding: '0px',
                    height: '540px',
                    display: 'flex',
                    flexDirection: 'column',
                }}
                className="overflow-hidden rounded-8"
                style={{ height: '540px' }}
            >
                <div
                    className="w-full h-full bg-darwin-neutral-50 text-13"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="h-full flex flex-col rounded-12 overflow-hidden">
                        <div className="px-16 py-12 flex items-center justify-between border-b border-darwin-neutral_new-200 bg-white">
                            <div className="flex items-center space-x-16">
                                <button
                                    className="flex items-center justify-center w-16 h-16"
                                    onClick={() => closeMe()}
                                >
                                    {backArrowIcon()}
                                </button>
                                <p className="text-20">Select bed</p>
                            </div>
                            <button className="p-6" onClick={() => closeMe()}>
                                {closeIcon('w-12 h-12 fill-darwin-neutral-1000')}
                            </button>
                        </div>

                        <div className="flex-1 overflow-auto grid grid-cols-4">
                            <div className="col-span-1 px-16 py-12 space-y-24 border-r border-darwin-neutral_new-200">
                                {/* <div className="flex items-center space-x-16">
                                <p>{preferencesIcon()}</p>
                                <p className="text-16 font-700">Preferences</p>
                            </div> */}
                                <div className="space-y-10">
                                    <p className="text-14 font-700 text-darwin-neutral_new-1000">
                                        Category
                                    </p>
                                    <div className="space-y-8">
                                        {this.cats.map((cat) => (
                                            <button
                                                key={cat.id}
                                                className={`w-max flex items-start space-x-16 px-12 py-6 border  ${
                                                    selectedCats?.has(cat.id)
                                                        ? ' border-darwin-accent-bright-blue-800 bg-darwin-accent-bright-blue-100'
                                                        : 'border-darwin-neutral_new-200'
                                                }  rounded-8`}
                                                onClick={() => this.onCatToggle(cat.id)}
                                            >
                                                <div className="space-y-4 text-left">
                                                    <p
                                                        className={`font-700 ${
                                                            selectedCats?.has(cat.id)
                                                                ? 'text-darwin-accent-bright-blue-800'
                                                                : ''
                                                        } `}
                                                    >
                                                        {cat.name}
                                                    </p>
                                                    <p className="text-11 text-darwin-neutrals-600">
                                                        {cat.description}
                                                    </p>
                                                </div>
                                                <div className="pt-6">
                                                    {closeIcon(
                                                        'w-10 h-10 fill-darwin-neutrals-600',
                                                    )}
                                                </div>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-3 flex flex-col bg-white">
                                {/* <div className="px-16 py-12 flex items-center justify-between border-b border-darwin-neutral_new-200">
                                <div className="flex items-center space-x-16">
                                    <p>{BedFilledIcon('w-18 h-14 fill-darwin-neutrals-600')}</p>
                                    <div className="flex items-center space-x-8 text-darwin-neutral_new-1000 font-700">
                                        <p>General, Room A, Bed 03</p>
                                        <p>from ₹2,000/night</p>
                                    </div>
                                </div>
                                <div className="flex items-center space-x-16">
                                    <button className="font-700 text-darwin-accent-bright-blue-800">
                                        View rate plans
                                    </button>
                                    <button className="font-700 text-darwin-accent-bright-blue-800">
                                        Estimate
                                    </button>
                                </div>
                            </div> */}

                                <div className="p-16 flex-1 overflow-auto">
                                    <div>
                                        <div
                                            className="flex items-center justify-between px-16 py-10 text-darwin-neutral_new-800"
                                            style={{ backgroundColor: '#E8E8E8' }}
                                        >
                                            <p className="text-11 font-700 uppercase"></p>

                                            <div className="flex items-center space-x-20">
                                                <div className="flex items-center space-x-5">
                                                    <p
                                                        className="w-12 h-12 border rounded-4 relative -top-1"
                                                        style={{
                                                            backgroundColor: '#19A66A',
                                                            borderColor: '#0F6440',
                                                        }}
                                                    ></p>
                                                    <p className="text-10">
                                                        Available: {avaialbleBeds?.size || '-'}
                                                    </p>
                                                </div>
                                                <div className="flex items-center space-x-5">
                                                    <p
                                                        className="w-12 h-12 border rounded-4 relative -top-1"
                                                        style={{
                                                            backgroundColor: '#D74B41',
                                                            borderColor: '#812D27',
                                                        }}
                                                    ></p>
                                                    <p className="text-10">
                                                        Occupied:{' '}
                                                        {this.beds.length -
                                                            (avaialbleBeds?.size || 0)}
                                                    </p>
                                                </div>
                                                <div className="flex items-center space-x-5">
                                                    <p
                                                        className="w-12 h-12 border rounded-4 relative -top-1"
                                                        style={{
                                                            backgroundColor: '#A3A3A3',
                                                            borderColor: '#767676',
                                                        }}
                                                    ></p>
                                                    <p className="text-10">Unavailable: 01</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="p-10 grid grid-cols-2 gap-8">
                                            {this.rooms
                                                .filter((t) => selectedCats.has(t.category))
                                                .map((room) => (
                                                    <div
                                                        key={room.id}
                                                        className="p-10 bg-darwin-neutrals-50 space-y-10 rounded-8"
                                                    >
                                                        <p className="text-10 font-700 text-darwin-neutral_new-800 uppercase">
                                                            {room.name}
                                                        </p>
                                                        <div className="flex flex-wrap gap-8">
                                                            {this.beds
                                                                .filter((t) => t.room === room.id)
                                                                .map((bed) => (
                                                                    <button
                                                                        onClick={() =>
                                                                            this.onBedSelect(bed.id)
                                                                        }
                                                                        disabled={
                                                                            !avaialbleBeds?.has(
                                                                                bed.id,
                                                                            )
                                                                        }
                                                                    >
                                                                        {avaialbleBeds?.has(bed.id)
                                                                            ? availableBed(
                                                                                  bed,
                                                                                  selectedBed ===
                                                                                      bed.id,
                                                                              )
                                                                            : occupiedBed(bed)}
                                                                    </button>
                                                                ))}

                                                            {/* {unavaiableBed()} */}
                                                        </div>
                                                    </div>
                                                ))}
                                        </div>
                                    </div>

                                    <div></div>
                                </div>
                            </div>
                        </div>

                        <div className="w-full px-16 py-12 flex items-center justify-between border-t border-darwin-neutral_new-200 bg-white">
                            <button
                                className="font-700 text-darwin-accent-bright-blue-800"
                                onClick={() => closeMe()}
                            >
                                Cancel
                            </button>
                            <button
                                className="primary-btn-v3 btn--small flex items-center space-x-8 px-16 py-8 disabled:opacity-70 disabled:cursor-not-allowed"
                                // disabled={isSubmitting}
                                onClick={() =>
                                    closeMe(
                                        this.beds.find((t) => t.id === selectedBed),
                                        this.rooms.find(
                                            (t) =>
                                                t.id ===
                                                this.beds.find((t) => t.id === selectedBed)?.room,
                                        )?.category,
                                    )
                                }
                            >
                                {/* {isSubmitting && (
                                <p>
                                    <svg
                                        className="w-15 h-15 fill-white animate-spin"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                    >
                                        <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                                    </svg>
                                </p>
                            )} */}
                                <p>Confirm</p>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default IpdBedSelect;

function unavaiableBed(bed: BedsEntity) {
    return (
        <div
            className="w-max border pt-5 p-4 rounded-6 flex items-center space-x-6 bg-white rounded-8"
            style={{ borderColor: '#E8E8E8' }}
        >
            <p
                className="w-20 h-32 border rounded-4 relative -top-1"
                style={{
                    backgroundColor: '#A3A3A3',
                    borderColor: '#767676',
                }}
            ></p>
            <p className="pr-4" style={{ color: '#767676' }}>
                {bed.name}
            </p>
        </div>
    );
}

function availableBed(bed: BedsEntity, isSelected: boolean) {
    return (
        <div
            className={`w-max border pt-5 p-4 rounded-6 flex items-center space-x-6 ${
                isSelected
                    ? 'bg-darwin-accent-bright-blue-800 text-white'
                    : 'bg-white text-darwin-green-primary'
            } rounded-8`}
            style={{ borderColor: '#E8E8E8' }}
        >
            <p
                className="w-20 h-32 border rounded-4 relative -top-1"
                style={
                    isSelected
                        ? { backgroundColor: '#fff' }
                        : {
                              backgroundColor: '#19A66A',
                              borderColor: '#0F6440',
                          }
                }
            ></p>
            <p className="pr-4">{bed.name}</p>
        </div>
    );
}

function occupiedBed(bed: BedsEntity) {
    return (
        <div
            key={bed.id}
            className="w-max border pt-5 p-4 rounded-6 flex items-center space-x-6 bg-white rounded-8"
            style={{ borderColor: '#E8E8E8' }}
        >
            <p
                className="w-20 h-32 border rounded-4 relative -top-1"
                style={{
                    backgroundColor: '#D74B41',
                    borderColor: '#812D27',
                }}
            ></p>
            <p className="pr-4" style={{ color: '#D74B41' }}>
                {bed.name}
            </p>
        </div>
    );
}
